import React from 'react'

import { Navigate, Outlet } from 'react-router'

import { useAcessoASimulacaoRapida } from '@/hooks'

type TSimulacaoRapidaGuardProps = {
  children?: React.ReactNode
}

export const SimulacaoRapidaGuard: React.FC<TSimulacaoRapidaGuardProps> = ({ children }) => {
  const { permiteAcesso, acessoCarregando } = useAcessoASimulacaoRapida()

  if (acessoCarregando) {
    return null
  }

  if (!permiteAcesso) {
    return <Navigate to="/es-CL" replace />
  }

  if (children) {
    return <>{children}</>
  }

  return <Outlet />
}
